// extracted by mini-css-extract-plugin
export default {"melodyVideo":"_P-z","isFullWidth":"aQ-z","landingPageVideo":"bQ-z","play":"cQ-z","iframeVideo":"dQ-z","playHidden":"eQ-z","fullwidth":"fQ-z"};